import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import Table from '../../../../../common/components/table';
import TenantBasicInfoComponent from './tenant-basic-info.component';
import TenantConfigurationInfoComponent from './tenant-configuration-info.component';
import TenantSubscriptionInfoComponent from '../containers/tenant-suscription-details.component';
import BusinessUserInfoComponent from './business-user-info.component';

export const TenantComponent = ({handleUpdateClick, tenantsDetails, back,columnDefs,rowData }: any) => {
  const tabItems=[
    {
        id:1,
        title:'Tenant Details',
        component:<TenantBasicInfoComponent
        tenantsDetails={tenantsDetails} 
        />,
    isVisible:true,
    },
    {
        id:2,
        title:'Business Channels',
        component:<Table
        columnData={columnDefs}
        rowData={rowData}
        headingName="Tenant Business Channels"
    />,
    isVisible:true,
    },
    {
        id:3,
        title:'Configurations',
        component:<TenantConfigurationInfoComponent
        tenantsDetails={tenantsDetails} 
        />,
    isVisible:true,
    },
    {
      id:4,
      title:'Business Users',
      component:<BusinessUserInfoComponent
      tenantsDetails={tenantsDetails} 
      />,
  isVisible:true,
  },
    {
      id:5,
      title:'Subscription Details',
      component:<TenantSubscriptionInfoComponent
      tenantsDetails={tenantsDetails} 
      />,
  isVisible:true,
  }
  ]
   
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
      <div className='flex w-full justify-end items-end'>
        <button
               onClick={handleUpdateClick}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
             Software Update
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleUpdateClick}
            
              type="submit"
          >
            Default Value Update
          </button>
        </div>
       
      <TabContainer tabItems={tabItems}/>
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
        </div>
       </div>
  )
}
export default TenantComponent;